function showComment(id,nazev,object) {
	$( ".komentar-popup" ).attr("title",nazev);
	$( ".komentar-popup" ).text("Komentář se načítá...");
	$( ".komentar-popup" ).dialog( "option" , "position" , {at: "right bottom", of: object, my: "right top"});
	$( ".komentar-popup" ).dialog({
		title: nazev, 
		dialogClass: "komentar-dialog",
		resizable: false, 
		draggable: false
	});
	$( ".komentar-popup" ).dialog( "open" );
	$('.ui-dialog :button').blur();
	$.ajax({
		url: "/share/ajax/snih_comment.php",
		type: "POST",
		dataType: "html",
		data: {id: id},
		success:  function (payload) {
				$( ".komentar-popup" ).text(payload);
		},
		error: function (jqxhr,status,error) {
			$( ".komentar-popup" ).dialog("close");
		}
	});	
	return false;
}

$(function() {
	var bDataLoaded = false;
	var bSearchRunning = false;
	var data = [];
	//var accentMap = settings.accentMap;
 
	function ajaxSearch(pattern) {
		if (bSearchRunning === false && pattern.length) {
			bSearchRunning = true;
			$("#snih-search-img").prop('disabled', true);
			$("#snih-search").prop('disabled', true);
			$("#snih-search-img").hide();
			$(".search_spinner").show();
			$.ajax({
				url: "/share/ajax/snih_vyhledavac.php",
				type: "POST",
				dataType: "html",
				data: {domain: settings.domain, pattern: pattern},
				success:  function (payload) {
						$("#snih-search-img").prop('disabled', false);
						$("#snih-search").prop('disabled', false);
						$("#snih-search-img").show();
						$("#tabsnih").hide();
						$("#tabsnih").after(payload);
						$(".search_spinner").hide();
						bSearchRunning = false;
						jumpToElement("link");
				},
				error: function (jqxhr,status,error) {
					$("#snih-search-img").prop('disabled', false);
					$("#snih-search").prop('disabled', false);
					$("#snih-search-img").show();
					$(".search_spinner").hide();
					bSearchRunning = false;
				}
			});
		}
		return false;
	} 	 
 
    $( "#snih-search" ).autocomplete({
		source: function( request, response ) {
			var term = normalize(request.term);
			var matcher = new RegExp('(^| )' + $.ui.autocomplete.escapeRegex( term ), "i" );
			response( $.grep( data, function( value ) {
				return matcher.test( normalize( value ) );
			}) );
		},
		select: function (event,ui) {
			if (event.keyCode != 13) {
				ajaxSearch(ui.item.value);
			}
			else {
				return false;
			}
		},
		open: function(event, ui) {
			if (settings.bMobile && (window.innerHeight < window.innerWidth)) {
				$('html, body').animate({
					scrollTop: $("#tabsnih").offset().top
				}, 300);
			}
		}
    }).data( "ui-autocomplete" )._renderItem = function( ul, item) {
				tucne(item.label, this.term);
				//var re = new RegExp('('+this.term+')', 'gi') ;
				//var t = item.label.replace(re,"<strong>$1</strong>");		
				return $( "<li>" )
					.append( $( "<a>" ).html( tucne(item.label, this.term) ) )
					.appendTo( ul );			
		};

	$(".komentar-popup").dialog({
		autoOpen: false,
		modal: true
	});

	// zavreni okna komentare pri kliku mimo
	$(document).on('click', '.ui-widget-overlay', function() {
			 $('.komentar-popup').dialog( "close" );
	});

	$("#snih-search").keyup(function (event) {
		if(event.keyCode == 13){
			$( "#snih-search" ).autocomplete("close");
			$( "#snih-search" ).blur();
			var pattern = $("#snih-search").val();
			ajaxSearch(pattern);
		} else if (!bDataLoaded) {
			$.ajax({
				url: "/share/ajax/snih_naseptavac.php",
				type: "POST",
				dataType: "json",
				data: {domain: settings.domain},
				success:  function (payload) {
						data = payload;
						bDataLoaded = true;
						$( "#snih-search").autocomplete("search");
					} 
			});
		}
	}); 
	
	$("#snih-search-img").click(function (){
		var pattern = $("#snih-search").val();
		pattern = $.trim(pattern);
		ajaxSearch(pattern);
	});
	
	$( "body" ).on("click", "#btn-na-puvodni", function() {
		$("#tabsnih").show();
		$("#tabsnihfiltr").remove();
		$("#snih-search").val("");

		// Reload, protoze obsah se zmenil
		$('table').stickyTableHeaders('destroy').stickyTableHeaders();
	});
	
	/*
    $( "body" ).on("click", ".komentar-icon", function() {
		var text = $(this).parent().next();
		var areal = text.attr("title");
		$( ".komentar-popup" ).text(text.html());
		$( ".komentar-popup" ).attr("title",areal);
		$( ".komentar-popup" ).dialog( "option" , "position" , {at: "right bottom", of: this, my: "right top"});
		$( ".komentar-popup" ).dialog({
			title: areal, 
			dialogClass: "komentar-dialog",
			resizable: false, 
			draggable: false
		});
		$( ".komentar-popup" ).dialog( "open" );
		$('.ui-dialog :button').blur();
		return false;
    });*/
  });



function jumpToElement(h){
	var top = document.getElementById(h).offsetTop;		//Getting Y of target element
	window.scrollTo(0, top);							//Go there directly or some transition
}
